import { FilterWorkerProvider } from "src/contexts/FilterWorkerContext";
import Breadcrumbs from "src/components/Manage/Reports/Instances/Breadcrumbs";
import ExpandedChart from "./Chart/Expand";
import Close from "src/components/Manage/Reports/Instances/Close";
import { OpaqueOverlay as StyledInstances } from "src/components/Manage/Workflow/styles";
import Table from "src/components/Manage/Workflow/Instances/Table";
import FileViewer from "src/components/Main/Viewer.js";

const Instance = () => {
  return (
    <FilterWorkerProvider>
      <StyledInstances>
        <Close />
        <Breadcrumbs />
        <ExpandedChart />
        <Table />
        <FileViewer />
      </StyledInstances>
    </FilterWorkerProvider>
  );
};

export default Instance;
